import { requestType } from '~/config/enum.config';
var SERVICE = 'repair-service';
var CONTROLLER = 'idCardInformation';
export default {
    searchIdCardInformation: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'searchIdCardInformation',
        type: requestType.Get
    },
};
